/**
 * TanStack Query hooks for `agency`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	agencyQueryKeys,
	type CreateAgencyBody,
	type ListAgencyResponse,
	type AgencyRow,
} from "./api";

export function useAgencyList(): UseQueryResult<ListAgencyResponse, Error> {
	return useQuery({
		queryKey: agencyQueryKeys.list(),
		queryFn: list,
	});
}

export function useAgencyCreate(): UseMutationResult<AgencyRow, Error, CreateAgencyBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: agencyQueryKeys.all });
		},
	});
}

export function useAgencyDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: agencyQueryKeys.all });
		},
	});
}
